module.exports = __webpack_public_path__ + "img/sv86.988b8640.svg";